import * as React from 'react';
import { ViewContainer } from '../ViewContainer';
import { TitleContainer } from '../TitleContainer';
import { Help } from '../../_NEXT_components/Help';
import { RestoreFormContainer } from '../RestoreFormContainer';
import { trackLoginNeedHelp } from '../../utils/tracking';
import { SubtitleLayout } from '../../_NEXT_components/SubtitleLayout';
export function RestoreViewContainer() {
  return /*#__PURE__*/React.createElement(ViewContainer, null, /*#__PURE__*/React.createElement(TitleContainer, null), /*#__PURE__*/React.createElement(SubtitleLayout, null, "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 email, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0432\u044B \u0443\u043A\u0430\u0437\u0430\u043B\u0438 \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438"), /*#__PURE__*/React.createElement(RestoreFormContainer, null), /*#__PURE__*/React.createElement(Help, {
    onClick: trackLoginNeedHelp
  }));
}